// 特色集合组件类 - 避免多实例冲突
class FeatureCollection {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.title-wrap .title');
    this.contentBlocks = container.querySelectorAll('slider-component');
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.handleTabClick(tab));
    });
  }

  handleTabClick(clickedTab) {
    // 移除当前容器内所有tab的active类
    this.tabs.forEach(tab => tab.classList.remove('active'));

        // 添加点击的tab的active类
    clickedTab.classList.add('active');

        // 获取点击tab的data-id属性值
    const dataId = clickedTab.getAttribute('data-id');

    // 隐藏当前容器内所有内容块
    this.contentBlocks.forEach(block => block.style.display = 'none');

    // 显示与点击tab相关的内容块（仅在当前容器内查找）
    const targetBlock = this.container.querySelector(`slider-component[data-id="${dataId}-block"]`);
        if (targetBlock) {
            targetBlock.style.display = 'block';
        }
  }

  // 销毁实例的方法
  destroy() {
    this.tabs.forEach(tab => {
      // 移除事件监听器
      tab.removeEventListener('click', this.handleTabClick);
    });
  }
}

// 实例管理器 - 避免重复初始化
const FeatureCollectionManager = {
  instances: new Map(),

  init() {
    // 查找所有特色集合容器
    const containers = document.querySelectorAll('.new-collection');

    containers.forEach((container, index) => {
      // 为每个容器分配唯一ID
      const instanceId = container.id || `feature-collection-${index}`;
      if (!container.id) {
        container.id = instanceId;
      }

      // 如果实例不存在，创建新实例
      if (!this.instances.has(instanceId)) {
        const instance = new FeatureCollection(container);
        this.instances.set(instanceId, instance);
      }
    });
  },

  // 销毁指定实例
  destroy(instanceId) {
    const instance = this.instances.get(instanceId);
    if (instance) {
      instance.destroy();
      this.instances.delete(instanceId);
    }
  },

  // 销毁所有实例
  destroyAll() {
    this.instances.forEach((instance) => {
      instance.destroy();
    });
    this.instances.clear();
  }
};

// 当DOM加载完成后初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    FeatureCollectionManager.init();
  });
} else {
  FeatureCollectionManager.init();
}

// 监听动态内容变化（如AJAX加载）
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // 检查新添加的节点是否包含特色集合组件
          if (node.classList?.contains('new-collection') ||
            node.querySelector?.('.new-collection')) {
            FeatureCollectionManager.init();
          }
        }
      });
    }
  });
});

// 开始观察DOM变化
observer.observe(document.body, {
  childList: true,
  subtree: true
});